"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
const InterfacesGen = require("./InterfacesGen");
const Metadata = require("./Metadata");
const MetadataUtils = require("./Metadata.utils");
const MetadataParser = require("./MetadataParser");
// named export to be used as 'import {something} from metadataLibrary
__exportStar(require("./Metadata"), exports);
__exportStar(require("./MetadataParser"), exports);
__exportStar(require("./Metadata.utils"), exports);
__exportStar(require("./InterfacesGen"), exports);
// default export to be used as 'import metadataLibrary; metadataLibrary.something()
// is this the right way to achieve this convenience?
exports.default = { ...Metadata, ...MetadataParser, ...MetadataUtils, ...InterfacesGen };
